export const TIMELINE_WS_PATH = 'timeline'
